import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import type { ExportReportPolygonParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

type ExportReportPrintPagePolygonProps = Readonly<{
  params: ExportReportPolygonParams;
  template: ReportTemplate;
}>;

export const ExportReportPrintPagePolygonComponent = ({
  template, params,
}: ExportReportPrintPagePolygonProps) => {
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel } = useExportReportData({
    tableColumns,
    template,
  });

  return (
    <ExportReportPrintPageWrapperComponent>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          heading: params.data.heading,
        }}
        mapProps={{
          type: params.type,
          paths: params.data.paths,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
